'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { SubMenuBase } from '@/app/components/layouts/top-navigation/sub-menu/base';
import type { NavItemType } from '@/app/types/top-navigation';
const SubMenuLcv = dynamic(() => import('@/app/components/layouts/top-navigation/sub-menu/lcv').then(mod => mod.SubMenuLcv), {
  ssr: false
});
const SubMenuCv = dynamic(() => import('@/app/components/layouts/top-navigation/sub-menu/cv').then(mod => mod.SubMenuCv), {
  ssr: false
});
const IS_LCV = process.env.NEXT_PUBLIC_WEB === 'lcv';
const IS_CV = process.env.NEXT_PUBLIC_WEB === 'cv';

// Note: Warm the current website's lazy sub menu chunk so the first hover doesn't wait for the network
export const preloadSubMenuLayouts = () => {
  if (IS_LCV) {
    void import('@/app/components/layouts/top-navigation/sub-menu/lcv');
  }
  if (IS_CV) {
    void import('@/app/components/layouts/top-navigation/sub-menu/cv');
  }
};
interface SubMenuRenderLayoutProps {
  activeItem?: NavItemType;
  isDesktop?: boolean;
  onReady?: () => void;
  onClose?: () => void;
}
export const SubMenuRenderLayout = t0 => {
  const $ = _c(15);
  const {
    activeItem,
    isDesktop: t1,
    onReady,
    onClose
  } = t0;
  const isDesktop = t1 === undefined ? false : t1;
  const pathname = usePathname();
  if (!activeItem) {
    return null;
  }
  if (activeItem.modelMenu === "cv") {
    let t2;
    if ($[0] !== isDesktop || $[1] !== onClose || $[2] !== onReady || $[3] !== pathname) {
      t2 = <SubMenuCv pathname={pathname} isDesktop={isDesktop} onReady={onReady} onClose={onClose} />;
      $[0] = isDesktop;
      $[1] = onClose;
      $[2] = onReady;
      $[3] = pathname;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (activeItem.modelMenu === "lcv") {
    let t2;
    if ($[5] !== onClose || $[6] !== onReady || $[7] !== pathname) {
      t2 = <SubMenuLcv pathname={pathname} onReady={onReady} onClose={onClose} />;
      $[5] = onClose;
      $[6] = onReady;
      $[7] = pathname;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t2;
  if ($[9] !== activeItem.as || $[10] !== activeItem.items || $[11] !== isDesktop || $[12] !== onClose || $[13] !== onReady) {
    t2 = <SubMenuBase as={activeItem.as} items={activeItem.items} isDesktop={isDesktop} onReady={onReady} onClose={onClose} />;
    $[9] = activeItem.as;
    $[10] = activeItem.items;
    $[11] = isDesktop;
    $[12] = onClose;
    $[13] = onReady;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};